import { render, staticRenderFns } from "./CmgManageGroupOrderBanner.vue?vue&type=template&id=addee53a&scoped=true&lang=pug"
import script from "./cmg-manage-group-order-banner.ts?vue&type=script&lang=ts&external"
export * from "./cmg-manage-group-order-banner.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgManageGroupOrderBanner.vue?vue&type=style&index=0&id=addee53a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addee53a",
  null
  
)

export default component.exports